// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "HM Sans Regular", "HMSansHebrew-Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif !important;
  overflow-y: scroll;
}

.footer {
  padding: 20px;
  width: 100%;
  position: relative;
  left: 0;
  bottom: 0;
}

.content-container {
  min-height: calc(100vh - 155px);
}

.tabBox {
  background-color: #FAF6F2;
  width: 100%;
  max-width: 1600px;
  min-height: calc(100vh - 230px);
}

@media screen and (min-width: 768px) {
  .modalInnerContainer {
    width: 1030px !important;
   }
}

.hm-width--200 {
  width: 200px;
}

/* ---------- MUI Overwrites ---------- */
.MuiTypography-body2 {
  font-family: "HM Sans Regular", "HMSansHebrew-Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif !important;
}

.margin-top-8 {
  margin-top: 8px !important;
}

.hm-text-field .MuiInputBase-root {
  font-family: "HM Sans Regular", "HMSansHebrew-Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  background-color: white;
  border-radius: 0;
}

.hm-text-field .MuiInputBase-root input:disabled:hover {
  cursor: wait;
}

.hm-text-field--single .MuiInputBase-root {
  width: 200px;
  height: 48px;
}

.hm-text-field--single .MuiInputBase-root input {
  padding: 0 !important;
}

.hm-select-options-text {
  font-family: "HM Sans Regular", "HMSansHebrew-Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  line-height: 1.25;
  font-size: 1rem;
}

/* ---------- CONTACTS ---------- */

.contacts_filter-fields > div{
  width: 20%;
}

/* ---------- PRINT LABEL ---------- */

/* Overwrite some MUI fonts */
.hmBodyText .MuiTypography-root {
  font-family: "HM Sans Regular", "HMSansHebrew-Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif !important;
  font-size: 0.875rem;
}

/* Label design */
.label {
  background: #fff;
  height: 500px;
  width: 500px;
  padding: 25px;
  margin-bottom: 32px;
}

.label-data {
  font-size: 1.3rem;
  font-weight: bold;
}

.label-data__row {
  vertical-align: top;
  line-height: 1.15;
}

.label-data__title {
  width: 30%;
  padding-right: 10px;
  text-transform: uppercase;
  font-size: .8em;
  padding-top: 3px;
}

.label-data__info {
  overflow-wrap: anywhere;
}

.label-data__row:not(:last-child) .label-data__info {
  padding-bottom: 10px;
  height: 35px;
}

.label-data__footer {
  padding-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,2KAA2K;EAC3K,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE;IACE,wBAAwB;GACzB;AACH;;AAEA;EACE,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,2KAA2K;AAC7K;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gKAAgK;EAChK,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gKAAgK;EAChK,iBAAiB;EACjB,eAAe;AACjB;;AAEA,mCAAmC;;AAEnC;EACE,UAAU;AACZ;;AAEA,sCAAsC;;AAEtC,6BAA6B;AAC7B;EACE,2KAA2K;EAC3K,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["body {\n  font-family: \"HM Sans Regular\", \"HMSansHebrew-Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif !important;\n  overflow-y: scroll;\n}\n\n.footer {\n  padding: 20px;\n  width: 100%;\n  position: relative;\n  left: 0;\n  bottom: 0;\n}\n\n.content-container {\n  min-height: calc(100vh - 155px);\n}\n\n.tabBox {\n  background-color: #FAF6F2;\n  width: 100%;\n  max-width: 1600px;\n  min-height: calc(100vh - 230px);\n}\n\n@media screen and (min-width: 768px) {\n  .modalInnerContainer {\n    width: 1030px !important;\n   }\n}\n\n.hm-width--200 {\n  width: 200px;\n}\n\n/* ---------- MUI Overwrites ---------- */\n.MuiTypography-body2 {\n  font-family: \"HM Sans Regular\", \"HMSansHebrew-Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif !important;\n}\n\n.margin-top-8 {\n  margin-top: 8px !important;\n}\n\n.hm-text-field .MuiInputBase-root {\n  font-family: \"HM Sans Regular\", \"HMSansHebrew-Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  background-color: white;\n  border-radius: 0;\n}\n\n.hm-text-field .MuiInputBase-root input:disabled:hover {\n  cursor: wait;\n}\n\n.hm-text-field--single .MuiInputBase-root {\n  width: 200px;\n  height: 48px;\n}\n\n.hm-text-field--single .MuiInputBase-root input {\n  padding: 0 !important;\n}\n\n.hm-select-options-text {\n  font-family: \"HM Sans Regular\", \"HMSansHebrew-Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  line-height: 1.25;\n  font-size: 1rem;\n}\n\n/* ---------- CONTACTS ---------- */\n\n.contacts_filter-fields > div{\n  width: 20%;\n}\n\n/* ---------- PRINT LABEL ---------- */\n\n/* Overwrite some MUI fonts */\n.hmBodyText .MuiTypography-root {\n  font-family: \"HM Sans Regular\", \"HMSansHebrew-Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif !important;\n  font-size: 0.875rem;\n}\n\n/* Label design */\n.label {\n  background: #fff;\n  height: 500px;\n  width: 500px;\n  padding: 25px;\n  margin-bottom: 32px;\n}\n\n.label-data {\n  font-size: 1.3rem;\n  font-weight: bold;\n}\n\n.label-data__row {\n  vertical-align: top;\n  line-height: 1.15;\n}\n\n.label-data__title {\n  width: 30%;\n  padding-right: 10px;\n  text-transform: uppercase;\n  font-size: .8em;\n  padding-top: 3px;\n}\n\n.label-data__info {\n  overflow-wrap: anywhere;\n}\n\n.label-data__row:not(:last-child) .label-data__info {\n  padding-bottom: 10px;\n  height: 35px;\n}\n\n.label-data__footer {\n  padding-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
